const roles = {
  OWNER: 'Gerente',
  OPERATOR: 'Operador',
  FACILITIES: 'Facilities',
  ON_DUTY: 'Plantonista',
};

export default roles;
